<template>
  <div>
    <p class="h5">
      Нотатки
      <b-icon class="ms-2" icon="chat-right-text" v-b-modal.modal-client-notes>
        Створити нотатку
      </b-icon>
    </p>
    <b-modal
      centered
      id="modal-client-notes"
      title="Створення нотатки"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="">
        <b-form-group
          label="Текст"
          label-form="textInput"
          invalid-feedback="Введіть текст нотатки"
        >
          <b-form-textarea
            id="textInput"
            @blur="$v.newNote.text.$touch()"
            v-model="newNote.text"
            :class="{
              'is-invalid': $v.newNote.text.$error && $v.newNote.text.$dirty,
            }"
          >
          </b-form-textarea>
        </b-form-group>
        <b-form-group
          label="Тип нотатки"
          class="mt-2"
          label-for="categoryInput"
          invalid-feedback="Оберіть тип нотатки!"
        >
          <b-form-select
            class="form-control"
            :options="categoryOptions"
            @blur="$v.newNote.category.$touch()"
            v-model="newNote.category"
            :class="{
              'is-invalid':
                $v.newNote.category.$error && $v.newNote.category.$dirty,
            }"
          >
          </b-form-select>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ClientNoteCreator",
  props: {
    clientId: Number,
  },
  data: function () {
    return {
      newNote: {
        text: null,
        admin_id: null,
        category: null,
        client_id: null,
      },
      categoryOptions: [
        { value: "success", text: "Звичайна" },
        { value: "danger", text: "Важлива" },
      ],
    };
  },
  validations: {
    newNote: {
      text: {
        required,
      },
      category: {
        required,
      },
    },
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    resetModal() {
      this.newNote = {
        text: null,
        admin_id: null,
        category: null,
        client_id: null,
      };
      this.$v.newNote.$reset();
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.newNote.admin_id = this.user.id;
      this.newNote.client_id = this.clientId;
      let response = await this.$api.clients.addNote(this.newNote);
      if (response) {
        this.$emit("refresh");
        this.$emit("showAlert", "Нотатка успішно створена!", "green");
        this.$nextTick(() => {
          this.$bvModal.hide("modal-client-notes");
        });
      }
    },
  },
};
</script>

<style scoped></style>
